"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transChoice;

function transChoice(translations, key, count = 1, replace = {}) {
  let translation = translations[key];

  if (!translation) {
    return key;
  } // Check plural


  const translationSpl = translation.split('|');

  if (translationSpl[1]) {
    translation = count !== 1 ? translationSpl[1] : translationSpl[0];
  } else {
    translation = translationSpl[0];
  } // Replace the {count} placeholder


  replace.count = count;

  for (var placeholder in replace) {
    try {
      translation = translation.replace(`:${placeholder}`, replace[placeholder]);
    } catch (error) {
      console.warn(`Placeholder ${placeholder} not found in key ${key}`);
    }
  }

  if (translation) return translation.trim();
  return key;
}